<div class="success-popup">
  <button type="button" class="close-btn" aria-label="Close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="success-icon">
    <mat-icon>check</mat-icon>
  </div>
  <p class="success-message">{{ message }}</p>
</div>
